// extracted by mini-css-extract-plugin
export default {"form":"Form_form__iQ3K6","input":"Form_input__GfAu+","btn":"Form_btn__a0I-I","div":"Form_div__GOhMS","error":"Form_error__blOjL"};